import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid, Card, Button, Box, Chip } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { Add as AddIcon, Edit } from "@mui/icons-material";
import { getRolesByCountry } from "../../redux/actions/GetRolesByCountryAction";
import AddRoleModal from "components/AddRoleModal";
import EditRoleModal from "components/EditRoleModal";

const selectedCountry = localStorage.getItem("selectedCountry");

const RolesTable = () => {
  const dispatch = useDispatch();
  const rolesResponse = useSelector((state) => state.rolesByCountry.roles);
  const fetchStatus = useSelector((state) => state.rolesByCountry.status);
  const [roles, setRoles] = useState([]);
  const [openAddModal, setOpenAddModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [selectedRole, setSelectedRole] = useState(null);

  useEffect(() => {
    if (rolesResponse) {
      const listRoles = rolesResponse.map((element) => ({
        id: element.idrole ?? element.idRole,
        idrole: element.idrole ?? element.idRole,
        roleName: element.roleName,
        isActive: element.isActive ?? false,
        addToAll: element.addToAll ?? false,
        countryId: element.country?.idcountry ?? element.country?.idCountry,
        countryName: selectedCountry ?? "",
      }));

      setRoles(listRoles);
    }
  }, [rolesResponse]);

  useEffect(() => {
    dispatch(getRolesByCountry());
  }, [dispatch]);

  const handleEditOpen = (row) => {
    setSelectedRole(row);
    setOpenEditModal(true);
  };

  const columns = [
    {
      field: "idrole",
      headerName: "ID",
      width: 80,
    },
    {
      field: "roleName",
      headerName: "Role Name",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "isActive",
      headerName: "Active",
      width: 120,
      renderCell: (params) => (
        <Chip
          label={params.value ? "Yes" : "No"}
          size="small"
          color={params.value ? "success" : "default"}
        />
      ),
    },
    {
      field: "addToAll",
      headerName: "Add To All",
      width: 130,
      renderCell: (params) => (
        <Chip
          label={params.value ? "Yes" : "No"}
          size="small"
          color={params.value ? "primary" : "default"}
          variant="outlined"
        />
      ),
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 120,
      sortable: false,
      renderCell: (params) =>
        params.row.roleName === "SuperAdmin" ? null : (
          <Button
            variant="contained"
            sx={{
              color: "#ffffff",
              backgroundColor: "#4b4bfa",
              minWidth: 40,
              "&:hover": { backgroundColor: "#3e3ed9" },
            }}
            onClick={() => handleEditOpen(params.row)}
          >
            <Edit />
          </Button>
        ),
    },
  ];

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Card>
          <div style={{ height: "100%", width: "100%" }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 2,
              }}
            >
              <h1 style={{ marginBottom: "0.5%" }}>Roles Management</h1>
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#4b4bfa",
                  color: "#ffffff",
                  "&:hover": { backgroundColor: "#3e3ed9" },
                }}
                onClick={() => setOpenAddModal(true)}
              >
                <AddIcon />
              </Button>
            </Box>
            <DataGrid
              rows={roles}
              columns={columns}
              pageSize={10}
              rowsPerPageOptions={[5, 10, 20]}
              disableSelectionOnClick
              loading={fetchStatus === "loading"}
              sx={{
                "& .MuiCircularProgress-root": { color: "#4b4bfa" },
                mt: 2,
              }}
            />
          </div>
        </Card>
      </Grid>

      <AddRoleModal
        open={openAddModal}
        onClose={() => setOpenAddModal(false)}
      />
      <EditRoleModal
        open={openEditModal}
        onClose={() => {
          setOpenEditModal(false);
          setSelectedRole(null);
        }}
        roleData={selectedRole}
      />
    </Grid>
  );
};

export default RolesTable;
